"use client";
import Login from "./content";
import { signIn } from "next-auth/react";
import { useEffect, useRef } from "react";
import { useParams } from "next/navigation";
import { isLocaleCode, localizePath } from "@/utils/localize-path";

const LoginMask: React.FC<{ loginToken: string }> = ({ loginToken }) => {
  const run = useRef(0);
  const params = useParams();
  const locale = isLocaleCode(params?.lang) ? params.lang : "de";
  useEffect(() => {
    if (loginToken && run.current === 0) {
      signIn("credentials", {
        token: loginToken,
        callbackUrl: localizePath("/account", locale),
        redirect: true,
      });
      run.current++;
    }
  }, []);

  return <Login />;
};
export default LoginMask;
